










































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import utils from '@/services/utils';

@Component
export default class StatementBody extends Vue {
  @Prop() readonly data!: any;

  @Prop() readonly sum!: number;

  @Prop() readonly currencyRate!: any;

  @Prop() readonly toggleMode!: boolean;

  AuthInstance = getModule(AuthModule, this.$store);

  utilsInstance = utils;

  nowCurrency = '';

  checkRole = false;

  created() {
    this.checkRole = ['AGENT', 'SUBAGENT'].includes(this.AuthInstance.user.role);
  }
}
